export function dimLabel(v) {
  const s = String(v || '').trim();
  if (!s) return '';
  if (['n/a', 'null', 'none', 'not classified'].includes(s.toLowerCase())) return 'Not Classified';
  return s;
}

export function isPlaceholderDim(v) {
  const s = String(v || '').trim();
  if (!s) return true;
  return ['n/a', 'na', 'nc', 'null', 'none', 'not classified'].includes(s.toLowerCase());
}
